import pkg from '../package.json';
import {CONFIG_NAMESPACE} from './constants';
import Search from './views/search';
import SelectContentChange from './views/select-content-change';
import Multiselect from './views/multiselect';
import Submit from './views/submit';
import $ from 'jquery';

const app = Voonto.getInstance();
const config = app.lookup(CONFIG_NAMESPACE);
_init(config);
app.on('voonto:reload', (event, context$) => _init(config, context$));


export const VERSION = pkg.version;
/* Private */

function _init(config, context$) {
  $('[data-voc-sportsdata-search]', context$).each(function() {new Search($(this), config);});
  $('[data-voc-sportsdata-select-content-change]', context$).each(function() {new SelectContentChange($(this));});
  $('[data-voc-sportsdata-multiselect]', context$).each(function() {new Multiselect($(this));});
  $('[data-voc-sportsdata-form-submit]', context$).each(function() {new Submit($(this));});
}



// WEBPACK FOOTER //
// ./src/autoload.js